import { useAppDispatch } from "../store";
import { asyncLogin, LoginFormValues, UserState } from "../store/userSlice";
import { useNavigate } from "react-router";
import LoginForm from "../components/Common/LoginForm";
import { UserRole } from "lib/types";

const Login = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const onLogin = async (values: LoginFormValues) => {
    const us = await dispatch(asyncLogin(values));

    const uss: UserState = us.payload as UserState;
    navigate(
      uss.role === UserRole.USER ||
        uss.role === UserRole.MANAGER ||
        uss.role === UserRole.ADMIN
        ? "/school"
        : "/"
    );
  };

  return (
    <div className="flex min-h-screen items-start justify-center bg-gray-50 px-4 py-12 sm:items-center sm:py-16">
      <div className="w-full max-w-sm rounded-xl border border-gray-200 bg-white p-6 shadow-sm sm:p-8">
        <div className="mb-6 flex flex-col items-center gap-2">
          <img src="/logo.svg" alt="Logo" width={40} height={40} />
          <div className="text-lg font-bold text-gray-900">SalesOnline</div>
        </div>
        <LoginForm onLogin={onLogin} />
      </div>
    </div>
  );
};

export default Login;
